import React from 'react';
import { Link2, FileText, Zap, Shield, Users, Download } from 'lucide-react';

export const Features = () => {
  const features = [
    {
      icon: Link2,
      title: 'Invitaciones por link',
      description: 'Sin instalar apps. Los estudiantes se unen con un simple link compartido por WhatsApp o email.',
      benefit: 'Cero fricción de entrada'
    },
    {
      icon: Zap,
      title: 'Control diario rápido',
      description: 'Toma asistencia en segundos desde cualquier dispositivo. Interface intuitiva y sin complicaciones.',
      benefit: 'Ahorra tiempo valioso'
    },
    {
      icon: FileText,
      title: 'Reportes automáticos',
      description: 'Genera reportes por estudiante, aula o periodo. Visualiza tendencias y patrones de asistencia.',
      benefit: 'Insights accionables'
    },
    {
      icon: Users,
      title: 'Gestión multi-aula',
      description: 'Administra todas tus aulas desde un solo lugar. Cambia entre clases con un clic.',
      benefit: 'Todo en un lugar'
    },
    {
      icon: Download,
      title: 'Exportación de datos',
      description: 'Descarga reportes en Excel o PDF. Comparte información con coordinación académica fácilmente.',
      benefit: 'Máxima flexibilidad'
    },
    {
      icon: Shield,
      title: 'Seguro y privado',
      description: 'Tus datos y los de tus estudiantes están protegidos. Cumplimos con estándares de privacidad.',
      benefit: 'Tranquilidad garantizada'
    }
  ];

  return (
    <section id="caracteristicas" className="py-20 lg:py-28 bg-gray-50">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl mx-auto text-center mb-16">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
            Todo lo que necesitas para{' '}
            <span className="text-blue-600">gestionar asistencia</span>
          </h2>
          <p className="text-lg text-gray-600">
            Características diseñadas para docentes y coordinadores académicos
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-8 max-w-7xl mx-auto">
          {features.map((feature, index) => {
            const Icon = feature.icon;
            return (
              <div
                key={index}
                className="bg-white rounded-2xl p-8 hover:shadow-xl transition-all duration-300 group border border-gray-100"
              >
                <div className="bg-blue-50 w-14 h-14 rounded-xl flex items-center justify-center mb-6 group-hover:bg-blue-100 transition-colors duration-300">
                  <Icon size={28} className="text-blue-600" strokeWidth={2} />
                </div>

                <h3 className="text-xl font-bold text-gray-900 mb-2">
                  {feature.title}
                </h3>

                <p className="text-gray-600 mb-4 leading-relaxed">
                  {feature.description}
                </p>

                <div className="inline-flex items-center text-sm font-medium text-blue-600">
                  {feature.benefit}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
